export enum CollectionSorting {
  DEFAULT = 'COLLECTION_DEFAULT',
  TITLE = 'title',
  PRICE_ASCENDING = 'price-ascending',
  PRICE_DESCENDING = 'price-descending',
  NEW = 'new',
  BEST_SELLING = 'best-selling',
}
